import { render } from "./BaseBadge.vue?vue&type=template&id=c3e6b896&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=c3e6b896&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3e6b896"

export default script